import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/NavBar";
import About from "./components/About";
import Home from "./components/Home";
import Wedding from "./components/Wedding";
import BabyShoot from "./components/BabyShoot";
import Outdoor from "./components/Outdoor";
import Maternity from "./components/Maternity";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import ScrollToTop from  "./components/ScrolltoTop";
import FirstPage from "./components/FirstPage";
import Contact from "./components/Contact";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<FirstPage />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/maternity" element={<Maternity />} />
          <Route path="/wedding" element={<Wedding />} />
          <Route path="/outdoor" element={<Outdoor />} />
          <Route path="/babyshoot" element={<BabyShoot />} />
          <Route path="/contact" element={<Contact/>}/>
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
